module.exports = "<div class=rm-grid-toolbar-user-management-role-management></div>";